import React from "react";
import { Container, Box, Breadcrumbs, Typography, Link as MUILink } from "@mui/material";

export default function PageContainer({
                                          title,
                                          breadcrumbs,
                                          children,
                                          actions,
                                          // sinnvolle Defaults: breite Seite mit leichtem Außenrand
                                          maxWidth = "lg",
                                          disableGutters = false,
                                          sx = {},
                                      }) {
    return (
        <Box sx={{ width: "100%" }}>
            <Container
                maxWidth={false}
                disableGutters={disableGutters}
                sx={{
                    px: 1,       // Rand links/rechts
                    pt: 3,       // Rand oben
                    ...sx,       // überschreibbar von außen
                }}
            >
                {(title || breadcrumbs || actions) && (
                    <Box
                        sx={{
                            mb: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            flexWrap: "wrap",
                        }}
                    >
                        <Box>
                            {breadcrumbs && breadcrumbs.length > 0 && (
                                <Breadcrumbs sx={{ mb: 0.5 }}>
                                    {breadcrumbs.map((b, i) => {
                                        const isLast = i === breadcrumbs.length - 1;
                                        const label = typeof b === "string" ? b : b?.label ?? "";
                                        const to = typeof b === "object" ? b?.to : undefined;

                                        // Letzter Eintrag: reiner Text
                                        if (isLast) {
                                            return (
                                                <Typography key={i} color="text.primary" component="span">
                                                    {label}
                                                </Typography>
                                            );
                                        }

                                        // Vorherige Einträge: Link, falls `to` vorhanden; sonst span
                                        return to ? (
                                            <MUILink key={i} underline="hover" color="inherit" href={to}>
                                                {label}
                                            </MUILink>
                                        ) : (
                                            <MUILink key={i} underline="hover" color="inherit" component="span">
                                                {label}
                                            </MUILink>
                                        );
                                    })}
                                </Breadcrumbs>
                            )}
                            {title && (
                                <Typography variant="h4" sx={{ fontWeight: 800 }}>
                                    {title}
                                </Typography>
                            )}
                        </Box>

                        {actions && <Box>{actions}</Box>}
                    </Box>
                )}

                <Box sx={{ pb: 2 }}>
                    {children}
                </Box>
            </Container>
        </Box>
    );
}
